import AcSection from "./modules/ac-section";
import { initPointers } from "./modules/ac-pointer";
const $ = require("jquery");
$(document).ready(() => {
    initPointers();
    document.querySelectorAll('.ac-section').forEach(el => {
        new AcSection(el);
    });
    $(document).on('select2:open', () => {
        let searchBox = document.querySelector('.select2-container--open .select2-search__field');
        if (searchBox) {
            searchBox.focus();
        }
    });
});
